import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/components/common/api';
import { roleMS } from '../../../models/roleMS.model';
import { RoleUserMS } from '../../../models/roleUserMS.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { RoleUserMSService } from '../../../services/utils/roleUserMS.service';

@Component({
  selector: 'app-rolesapplication-users',
  providers: [],
  templateUrl: './rolesApplicationUsers.component.html'
})

export class RolesApplicationUsersComponent implements OnInit {

  @Input() role: roleMS;
  @Output() onBack: EventEmitter<any> = new EventEmitter();
  customButtons: DataTableCustomButton[];
  usersRoleMSTitles: DataTableField[];
  selectedUserRoleMS: RoleUserMS = null;
  roleUsers: RoleUserMS[];
  paginationType = KontableComponent.ClientPagination;
  newDataAvailable = false;
  showDetail = false;
  modalTitle = '';
  labels = {}

  constructor (
    private translate: TranslateService,
    public srvRoleUserMS: RoleUserMSService,
    private srvTranslate: TranslateService,
    private srvDataTable: DataTableService,
    private srvNotify: MessageService
  ) {
    this.translate.get([
      'userForm.login',
      'userForm.name',
      'userForm.surname',
      'common.back',
      'userForm.add_title',
      'userForm.edit_title'
    ]
    ).subscribe((res) => {
      this.usersRoleMSTitles = [
        {id: 'id', label: '#'},
        {id: 'user_name', label: res['userForm.name']},
        {id: 'user_surname', label: res['userForm.surname']},
        {id: 'user_login', label: res['userForm.login']}
      ];

      this.customButtons = [
        {label: res['common.back'], callbackname: 'back', icon: 'fa fa-reply', isAlwaysEnabled: true},
      ];

      this.labels['add_title'] = res['userForm.add_title'];
      this.labels['edit_title'] = res['userForm.edit_title'];

    });

  }

  ngOnInit(): void {

    this.srvRoleUserMS.getAll(this.role).subscribe((res) => {
      this.roleUsers = res
    });
  }

  buildRoleUser(event): RoleUserMS {
    this.modalTitle = event == null ? this.labels['add_title'] : this.labels['edit_title'];
    let roleUserMS: RoleUserMS = {
      id: this.selectedUserRoleMS == null ? 0 : this.selectedUserRoleMS.id,
      user_id: event,
      user_surname: null,
      user_name: null,
      user_login: null,
      role: this.role
    };
    return roleUserMS;
  }

  save(event): void {
    this.srvDataTable.get('dt_roles_users').showDetail = false;
    let roleUser: RoleUserMS = this.buildRoleUser(event);
    console.log(roleUser);
    if (this.selectedUserRoleMS == null) {
      this.srvRoleUserMS.post(roleUser).subscribe(() => {
        this.srvRoleUserMS.getAll(this.role).subscribe(res => {
          this.roleUsers = res;
          this.srvTranslate.get(['roleMS.success']).subscribe(res2 => {
            this.srvNotify.add({severity: 'info', summary: 'Success', detail: res2['roleMS.success']});
          });
        });
      });
    } else {
      this.srvRoleUserMS.put(roleUser).subscribe(() => {
        this.srvRoleUserMS.getAll(this.role).subscribe((res) => {
          this.roleUsers = res
        });
      });
    }
    this.selectedUserRoleMS = null;
    this.showDetail = false;
  }

  remove(event): void {
    this.selectedUserRoleMS = event;
    this.srvRoleUserMS.delete(this.selectedUserRoleMS).subscribe(() => {
      this.srvRoleUserMS.getAll(this.role).subscribe((res) => {
        this.roleUsers = res
      });
    });
  }

  editUserRole(event): void {
    this.modalTitle = event == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.selectedUserRoleMS = event;
    this.showDetail = true;
  }

  customButton(event): void {
    this.onBack.emit(event);
  }

  closeDialogDetail() {
    this.showDetail = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/rolesApplication/rolesApplicationUsers.component.ts